import ClipboardJS from 'clipboard';

export default function initClipboard() {
	var clipboard = new ClipboardJS('.copy-to-clipboard');

	clipboard.on('success', function (e) {
		var $message = $(e.trigger).find('.message');
		$message.fadeIn();
		setTimeout(function () { $message.fadeOut(); }, 1000);
	});
}
